/* eslint-disable import/no-anonymous-default-export */
export default (receivingBranch = [], action) => {
  switch (action.type) {
    case "GET_ALL_RECEIVING_ADVICE":
      return action.payload;

    default:
      return receivingBranch;
  }
};
